module.exports = __webpack_public_path__ + "img/no_data.a64b1f54.png";